import { render, staticRenderFns } from "./Infographic1.vue?vue&type=template&id=43988a03&scoped=true&"
import script from "./Infographic1.vue?vue&type=script&lang=js&"
export * from "./Infographic1.vue?vue&type=script&lang=js&"
import style0 from "./Infographic1.vue?vue&type=style&index=0&id=43988a03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43988a03",
  null
  
)

export default component.exports